export default __webpack_public_path__ + "static/media/football_logo.1fb2cb7c.png";